module.exports = __webpack_public_path__ + "img/icon_4_17.6822837b.png";